import React from 'react';
import loadable from '@loadable/component';

import { withError } from '../../shared/components/error-boundary';
import useSEO from '../../hooks/useSEO';
import usePageComponents from '../../hooks/usePageComponents';
import useDeviceInfo from '../../hooks/useDeviceInfo';
import { StaticHtml } from '../../ui/components/static-content';
import { Helpers } from '../../core/src/helpers';

const SeoTabs = loadable(() => Helpers.retryFunc(() => import('./seo-tabs')));
const SeoAccordion = loadable(() => Helpers.retryFunc(() => import('./seo-accordion')));
const RichContent = loadable(() => Helpers.retryFunc(() => import('../../utility/components/rich-content')));

import './seo-paragraph.less';

const seoParagraphHasContent = seoParagraph => {
    /**
     * No seo paragraph, no visual content!
     */
    if (!seoParagraph) {
        return false;
    }

    let parsedParagraph = typeof seoParagraph === 'string' ? JSON.parse(seoParagraph) : seoParagraph;

    /**
     * If there's just nothing but an empty object {}
     */
    if (!Object.keys(parsedParagraph).length) {
        return false;
    }

    /**
     * If there's only one line && that line is empty
     */
    const { blocks = [] } = parsedParagraph;
    if (blocks.length === 0 || (blocks.length === 1 && blocks[0].text.trim() === '')) {
        return false;
    }

    return true;
};

const getTabs = ({ copyBlock, hideCopyBlock, comingSoon }) => {
    let tabs = [];
    const { contentLabel, content, css, enabled } = comingSoon || {};
    try {
        if (!hideCopyBlock && seoParagraphHasContent(copyBlock)) {
            tabs.push({
                label: 'More about these products',
                content: <RichContent className="seo-paragraph cust-html" raw={copyBlock} isV2={true} />,
                gtmActions: { category: 'linkClick', id: 'other', value: 'more-about-these-products' },
            });
        }
        //when there is coming soon rich content and coming is NOT enabled then we show the content in the seo tabs section instead
        if (!enabled && content && contentLabel) {
            tabs.push({
                label: contentLabel,
                content: <StaticHtml css={css} content={content} />,
                gtmActions: { category: 'linkClick', id: 'other', value: 'rich-content' },
            });
        }
    } catch (e) {}

    return tabs;
};

export default withError(props => {
    const { copyBlock, hideCopyBlock } = useSEO();
    const { comingSoon } = usePageComponents(['comingSoon', 'comingSoonContent']);
    const tabs = getTabs({ copyBlock, hideCopyBlock, comingSoon });
    const { isBot, device } = useDeviceInfo(['isBot', 'device']);
    if (tabs.length < 1) {
        return null;
    }

    if (device === 'mobile') {
        return <SeoAccordion tabs={tabs} isBot={isBot} />;
    } else {
        return <SeoTabs tabs={tabs} isBot={isBot} />;
    }
});
